import Vue from 'vue';
import VueRouter from 'vue-router';
import serviceHub from '@/services/hub';
import routes from './routes';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = serviceHub.api.defaults.headers.common.Authorization;
  if (to.matched.some((record) => record.meta.requiresAuth) && !isAuthenticated) {
    next({ name: 'Error', params: { error: '401' } });
  } else next();
});

export default router;
